// extracted by mini-css-extract-plugin
module.exports = {"container":"container-3dH_y6lKA6UyyqECYe6_jD","star":"star-2nuopFcWVHk2IQG-T0Yq0a","loadingSpinner":"loadingSpinner-2bDfcVV1BmY3NrDg6xpgCm"};